// extracted by mini-css-extract-plugin
export default {"fullWidth":"no-z","image":"oo-z","lazyLoadPicture":"po-z","lazyLoadSpinner":"qo-z","lazyLoadSpin":"ro-z","lazyLoadImage":"so-z","hasStyledAspectRatio":"to-z"};